import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderModule } from '@libs/shared/components/loader/loader.module';
import { VerificationCallbackComponent } from './verification-callback.component';
import { LoanService } from '@libs/services/loan.service';
import { VerificationCallbackRoutingModule } from './verification-callback-routing.module';

@NgModule({
  declarations: [VerificationCallbackComponent],
  exports: [VerificationCallbackComponent, VerificationCallbackRoutingModule],
  imports: [CommonModule, LoaderModule, VerificationCallbackRoutingModule],
  providers: [LoanService],
})
export class VerificationCallbackModule {}
